module.exports = __webpack_public_path__ + "img/metamask.09d133de.svg";